// @need-translate
import {t} from '../common/getTranslations';
import {ErrorArea} from '../design-system/organisms/ErrorArea/ErrorArea';

export function ItemNotSaleError({
  isMobile,
  onClickGoToHome,
}: {
  isMobile: boolean;
  onClickGoToHome?: () => void;
}) {
  return (
    <ErrorArea isMobile={isMobile}>
      <ErrorArea.Title>
        판매중이 아닌 작품과 회차는 <br /> 이용할 수 없습니다.
      </ErrorArea.Title>
      {onClickGoToHome && (
        <ErrorArea.LabelButton onClick={onClickGoToHome}>
          {t('contenthome_home_button')}
        </ErrorArea.LabelButton>
      )}
    </ErrorArea>
  );
}
